// Basic
import React from 'react';
import PropTypes from 'prop-types';
// Libs
import { useTranslation } from 'react-i18next';
// Store & actions
import useDeviceSizeStore from '@/app/store/deviceSize';
// Components
import RenderDropdownAction from './components/RenderDropdownAction';
import RenderSingleAction from './components/RenderSingleAction';
import genUID from '@/common-utils/functions/generateUniqueId';


/**
 * @param root0
 * @param root0.actions
 * @param root0.retractable
 * @param root0.className
 * @returns {JSX} PageActions
 */
function PageActions({ actions, retractable = false, className }) {
    // Translation
    const { t: translate } = useTranslation();

    // Constants
    const visibleActions = actions.filter((action) => action.visible);

    // Store
    const isSmallDevice = useDeviceSizeStore(state => state.isSmallDevice);
    const isMediumDevice = useDeviceSizeStore(state => state.isMediumDevice);

    return (
        <div className={`flex flex-wrap gap-2 mb-4 ${className}`}>
            {
                visibleActions.map((action, index) => {
                    if (action.render) {
                        return <React.Fragment key={genUID()}>
                            {action.render()}
                        </React.Fragment>;
                    }
                    if (action.isDropdown) {
                        return (
                            <RenderDropdownAction
                                key={genUID()}
                                action={action}
                                isMediumDevice={isSmallDevice || isMediumDevice}
                                retractable={retractable}
                                translate={translate}
                                variant={action?.trigger?.variant ?? (index === 0 ? 'primary' : 'secondary')
                                }
                            />
                        );
                    }
                    else {
                        return (
                            <RenderSingleAction
                                key={genUID()}
                                action={action}
                                isMediumDevice={isSmallDevice || isMediumDevice}
                                retractable={retractable}
                                translate={translate}
                                variant={action.variant ?? (index === 0 ? 'primary' : 'secondary')}
                            />
                        );
                    }
                })
            }
        </div >
    );
}

PageActions.propTypes = {
    actions: PropTypes.array.isRequired,
    retractable: PropTypes.bool,
    className: PropTypes.string
};

export default PageActions;